import { render, staticRenderFns } from "./WizardStep3.vue?vue&type=template&id=549ef466&"
import script from "./WizardStep3.vue?vue&type=script&lang=js&"
export * from "./WizardStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports